import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { EnvelopeSimple, Phone, MapPin, Clock, WhatsappLogo, Buildings } from "@phosphor-icons/react";
import { BUSINESS } from "@/lib/site";

function InfoCard({ icon: Icon, label, value, href, testid }) {
  const content = (
    <div data-testid={testid} className="bg-card border border-white/10 p-5 hover:border-primary/40 transition-colors h-full">
      <Icon size={24} weight="duotone" className="text-primary mb-3" />
      <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500 mb-1">{label}</p>
      <p className="text-white font-semibold break-words">{value}</p>
    </div>
  );
  return href ? <a href={href} className="block">{content}</a> : content;
}

export default function Contact() {
  return (
    <div className="min-h-screen bg-background grain">
      <Navbar />
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-14">
        <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.3em] text-primary mb-3">
          <Buildings weight="fill" size={16} /> Hubungi Kami
        </p>
        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tight">Kontak</h1>
        <p className="text-zinc-500 mt-3 max-w-2xl">Ada pertanyaan seputar tiket, pembayaran, atau acara? Tim {BUSINESS.name} siap membantu Anda.</p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <InfoCard testid="contact-email" icon={EnvelopeSimple} label="Email" value={BUSINESS.email} href={`mailto:${BUSINESS.email}`} />
          <InfoCard testid="contact-phone" icon={Phone} label="Telepon" value={BUSINESS.phone} href={`tel:${BUSINESS.phone}`} />
          <InfoCard testid="contact-whatsapp" icon={WhatsappLogo} label="WhatsApp" value={BUSINESS.phone} href={`https://wa.me/${BUSINESS.phoneIntl}`} />
          <InfoCard testid="contact-hours" icon={Clock} label="Jam Layanan" value={BUSINESS.hours} />
        </div>

        <div className="mt-4 grid gap-4 lg:grid-cols-5">
          <div data-testid="contact-address" className="lg:col-span-2 bg-card border border-white/10 p-6">
            <MapPin size={24} weight="duotone" className="text-primary mb-3" />
            <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500 mb-1">Alamat Usaha</p>
            <p className="font-heading font-bold text-white text-lg mb-2">{BUSINESS.name}</p>
            <p className="text-zinc-400 leading-relaxed">{BUSINESS.address}</p>
          </div>
          <div className="lg:col-span-3 border border-white/10 overflow-hidden">
            <iframe
              title="Lokasi Usaha"
              data-testid="contact-map"
              src={`https://www.google.com/maps?q=${encodeURIComponent(BUSINESS.address)}&output=embed`}
              className="w-full h-full min-h-[280px]"
              style={{ border: 0, filter: "grayscale(0.3) invert(0.92) hue-rotate(180deg)" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
